import { render, staticRenderFns } from "./AkunSatuSehat.vue?vue&type=template&id=3f25bf0c"
import script from "./AkunSatuSehat.vue?vue&type=script&lang=js"
export * from "./AkunSatuSehat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports